// Kosovalı Döner - Mock Data

export const restaurantInfo = {
  name: "Kosovalı Döner",
  tagline: "Gerçek Lezzetin Güvencesi",
  since: "1990",
  slogan: "1990'dan Günümüze",
  description: "100% Helâl kesim etlerle, kalite ve hijyen standartlarına uygun lezzetler üretiyoruz. Her lokmasında güven, her tabakta gelenek.",
  phone1: "0507 777 1990",
  phone2: "0212 887 1990",
  whatsapp: "905077771990",
  whatsappDisplay: "0507 777 1990",
  address: "Oruçreis Mah. Giyimkent 16. Sok. No:1-21 D: 9053 Esenler / İSTANBUL",
  hours: "09:00 - 18:00",
  instagram: "kosovalidoner1990",
  domain: "kosovalidoner.com",
  logo: "https://customer-assets.emergentagent.com/job_d1827898-4505-4b5f-8b55-2e8fe461c746/artifacts/bihz0xtk_logo.png",
  heroImage: "https://customer-assets.emergentagent.com/job_d1827898-4505-4b5f-8b55-2e8fe461c746/artifacts/lwdvirhg_kosovali-doner.jpeg",
  storeImage: "https://customer-assets.emergentagent.com/job_d1827898-4505-4b5f-8b55-2e8fe461c746/artifacts/cv5bj8jn_WhatsApp%20Image%202025-12-29%20at%2016.41.38.jpeg"
};

export const menuCategories = [
  {
    id: 1,
    name: "Et Döner",
    icon: "🥩",
    items: [
      {
        id: 101,
        name: "Porsiyon Döner",
        description: "Pilav, Pişmiş Soğan, Patates ile servis edilir.",
        variants: [
          { size: "100gr", price: 440 },
          { size: "120gr", price: 520 },
          { size: "150gr", price: 590 },
          { size: "200gr", price: 780 },
          { size: "250gr", price: 960 }
        ],
        image: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/3rp6figb_doner-menu.jpg"
      },
      {
        id: 102,
        name: "Ekmek Arası Döner",
        description: "Lavaş, Tombik Ekmek, Tırnak Pide (Pişmiş Soğan, Domates, Patates)",
        variants: [
          { size: "70gr", price: 300 },
          { size: "100gr", price: 380 },
          { size: "120gr", price: 450 },
          { size: "150gr", price: 540 },
          { size: "200gr", price: 730 }
        ],
        image: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/ytazqq8d_tombik-doner.jpg"
      }
    ]
  },
  {
    id: 2,
    name: "Lahmacun",
    icon: "🫓",
    items: [
      {
        id: 201,
        name: "Kosovalı İmza Lahmacun",
        description: "Salata ile servis edilir.",
        price: 170,
        image: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/uxf7uoia_lahmacun.jpg"
      },
      {
        id: 202,
        name: "Cevizli Lahmacun",
        description: "Salata ile servis edilir.",
        price: 150,
        image: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/uxf7uoia_lahmacun.jpg"
      },
      {
        id: 203,
        name: "Acılı - Acısız Lahmacun",
        description: "Salata ile servis edilir.",
        price: 150,
        image: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/uxf7uoia_lahmacun.jpg"
      }
    ]
  },
  {
    id: 3,
    name: "Pide",
    icon: "🥖",
    items: [
      { id: 301, name: "Kaşarlı Pide", price: 330 },
      { id: 302, name: "Kıymalı Pide", price: 400 },
      { id: 303, name: "Kuşbaşılı Pide", price: 400 },
      { id: 304, name: "Döner Kaşarlı Pide", price: 420 },
      { id: 305, name: "Sucuklu Kaşarlı Pide", price: 370 },
      { id: 306, name: "Kıymalı Kaşarlı Pide", price: 410 },
      { id: 307, name: "Kuşbaşılı Kaşarlı Pide", price: 410 },
      { id: 308, name: "Kavurmalı Kaşarlı Pide", price: 420 },
      { id: 309, name: "Pastırmalı Kaşarlı Pide", price: 450 },
      { id: 310, name: "Kosovalı İmza Pide", description: "Kavurma, Pastırma, Kuşbaşı, Kaşar", price: 490, featured: true }
    ]
  },
  {
    id: 4,
    name: "Yan Ürünler",
    icon: "🍟",
    items: [
      { id: 401, name: "Süzme Mercimek Çorbası", price: 100 },
      { id: 402, name: "Patates Kızartması", price: 100 },
      { id: 403, name: "Tereyağlı Bulgur Pilavı", price: 100 }
    ]
  },
  {
    id: 5,
    name: "Tatlılar",
    icon: "🍮",
    items: [
      { id: 501, name: "Hayrabolu Tatlısı", description: "Tahin ve Fındık ile servis edilir.", price: 120 },
      { id: 502, name: "Fırın Sütlaç", description: "Fındık ile servis edilir.", price: 120 }
    ]
  },
  {
    id: 6,
    name: "İçecekler",
    icon: "🥤",
    items: [
      { id: 601, name: "Coca Cola", price: 85 },
      { id: 602, name: "Sprite", price: 85 },
      { id: 603, name: "Fanta", price: 85 },
      { id: 604, name: "Cappy Meyve Suyu", price: 85 },
      { id: 605, name: "Ice Tea", price: 85 },
      { id: 606, name: "Beypazarı Soda", price: 25 },
      { id: 607, name: "Açık Ayran", price: 60 },
      { id: 608, name: "Reyhanlı Ayran", price: 70 },
      { id: 609, name: "Susurluk Ayran", price: 80 },
      { id: 610, name: "Şalgam", price: 60 },
      { id: 612, name: "El Yapımı Limonata", price: 90 },
      { id: 611, name: "Su", price: 25 }
    ]
  }
];

export const reviews = [
  {
    id: 1,
    name: "Ahmet Y.",
    rating: 5,
    text: "1990'dan beri gelen lezzet aynen devam ediyor. Et döner muhteşem, tereyağlı pilav ile birlikte yenmeli!",
    date: "2 hafta önce"
  },
  {
    id: 2,
    name: "Fatma K.",
    rating: 5,
    text: "Helal kesim konusunda güvendiğim tek yer. Lahmacunları da çok lezzetli. Kesinlikle tavsiye ederim.",
    date: "1 ay önce"
  },
  {
    id: 3,
    name: "Mehmet S.",
    rating: 5,
    text: "Kosovalı İmza Pide mutlaka denenmeli! Kavurma, pastırma ve kuşbaşı bir arada, muazzam bir lezzet.",
    date: "3 hafta önce"
  },
  {
    id: 4,
    name: "Ayşe D.",
    rating: 5,
    text: "WhatsApp'tan sipariş verdim, çok hızlı geldi. Döner sıcacık ve taze. Teşekkürler Kosovalı!",
    date: "1 hafta önce"
  },
  {
    id: 5,
    name: "Mustafa E.",
    rating: 5,
    text: "Esenler'in en iyi dönercisi. 35 yıllık tecrübe kendini belli ediyor. Her lokma ayrı lezzetli.",
    date: "2 ay önce"
  }
];

export const features = [
  {
    icon: "halal",
    title: "%100 Helal",
    description: "Tüm etlerimiz helal kesim sertifikalıdır."
  },
  {
    icon: "quality",
    title: "TSE Onaylı",
    description: "Kalite ve hijyen standartlarına tam uyum."
  },
  {
    icon: "tradition",
    title: "1990'dan Beri",
    description: "35 yıllık tecrübe ve gelenek."
  },
  {
    icon: "delivery",
    title: "Hızlı Teslimat",
    description: "WhatsApp ile kolay sipariş."
  }
];

export const galleryImages = [
  {
    src: "https://customer-assets.emergentagent.com/job_d1827898-4505-4b5f-8b55-2e8fe461c746/artifacts/lwdvirhg_kosovali-doner.jpeg",
    alt: "Kosovalı Döner Dış Mekan"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_d1827898-4505-4b5f-8b55-2e8fe461c746/artifacts/cv5bj8jn_WhatsApp%20Image%202025-12-29%20at%2016.41.38.jpeg",
    alt: "Kosovalı Döner İç Mekan"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/1iy8tp24_doner-durum.jpg",
    alt: "Döner Dürüm"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/3rp6figb_doner-menu.jpg",
    alt: "Porsiyon Döner Menü"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/ytazqq8d_tombik-doner.jpg",
    alt: "Tombik Ekmek Döner"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/uxf7uoia_lahmacun.jpg",
    alt: "Lahmacun"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/2j4m9fcw_lahmacun-doner.jpg",
    alt: "Lahmacun Döner"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/26ztyse8_pide1.jpg",
    alt: "Kuşbaşılı Kaşarlı Pide"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/jvygis53_pide2.jpg",
    alt: "Kıymalı Pide"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/zffx51tg_pide3.jpg",
    alt: "Kıymalı Kaşarlı Pide"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/mrjfsz2a_pide4.jpg",
    alt: "Karışık Pide"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/tzcxg6nt_pide5.jpg",
    alt: "Sucuklu Kaşarlı Pide"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/141m4m2j_kiymali-kasarli-pide.jpg",
    alt: "Kıymalı Kaşarlı Pide"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/73tbloqm_kusbasili-kasarli-pide.jpg",
    alt: "Kuşbaşılı Kaşarlı Pide"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/g6ivsoqc_kasarli-pastirmali-pide.jpg",
    alt: "Kaşarlı Pastırmalı Pide"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/guh9enh1_kasarli-pide.jpg",
    alt: "Kaşarlı Pide"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/7b2hg73g_hayrabolu-tatlisi.jpg",
    alt: "Hayrabolu Tatlısı"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/29dyi686_karisik-tost.jpg",
    alt: "Karışık Tost"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/yhoa29dy_kasarli-tost.jpg",
    alt: "Kaşarlı Tost"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/0bslwo7p_sutlac.jpg",
    alt: "Fırın Sütlaç"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_347520e5-72dc-43c0-a21d-066426efaab6/artifacts/9e6zatcq_bazlama-tost.jpg",
    alt: "Bazlama Tost"
  }
];